import React from "react";

import Button from "components/botanic/Button";

import { AgeGateFormProps } from "./AgeGate";

const UsAgeGateForm: React.FC<AgeGateFormProps> = ({ confirm, decline }) => (
  <>
    <div className="my-lg font-bold text-sm">Are you 21 or older?</div>
    <div className="flex flex-col md:flex-row gap-3">
      <Button
        data-testid="age-gate-no-button"
        variant="tertiary"
        onClick={decline}
        className="text-sm max-w-[100%]"
      >
        not yet
      </Button>
      <Button
        variant="primary"
        onClick={confirm}
        className="text-sm max-w-[100%]"
        data-testid="age-gate-yes-button"
      >
        you bet!
      </Button>
    </div>
  </>
);

export default UsAgeGateForm;
